{
  "Clear filters": "Rensa filter",
  "no-search-match": "Inga träffar på din sökning",
  "no-search-match-type": "Hittade inga {{type}} på din sökning",
  "Edit": "Redigera",
  "Resource": "Verktyg",
  "Content": "Content",
  "All spaces": "Alla områden",
  "All providers": "Alla partners",
  "All types": "Alla typer",
  "All categories": "Alla kategorier",
  "All subjects": "Alla ämnen",
  "Resources": "Verktyg",
  "Type": "Alla innehållstyper",
  "Manually added": "Tillagd manuellt",
  "userId": "AnvändarID",
  "id": "ID",
  "Licenses": "Licenser",
  "username": "Användarnamn",
  "Info": "Info",
  "No matches": "Inga träffar",
  "A page that includes a single learning item.": "En sida som innehåller ett lärobjekt.",
  "Possibility to use all formats below": "Möjlighet att använda alla format nedan",
  "Upload image(s)": "Ladda upp bilder",
  "Upload audio file(s)": "Ladda upp ljudfiler",
  "Upload xAPI/HTML5 package": "Ladda upp xAPI/HTML5-paket",
  "Upload downloadable item(s)": "Ladda upp nedladdningsbara filer",
  "Upload or link to video(s)": "Ladda upp eller länka till videos",
  "A lecture, workshop, or presentation": "En föreläsning, workshop eller presentation",
  "Participants meet virtually": "Deltagarna träffas virtuellt",
  "Participants meet in a physical location": "Deltagarna träffas på en fysisk plats",
  "A compilation of learning items of different types, formats, and delivery modes that are completed in a specific order, linked to and built by a 3rd party provider or in Learnifier.": "Ett hopplock av lärobjekt av olika typer, format och leveransmetoder som ska slutföras i en speciell ordning. Lärvägen är länkad till och/eller byggd av en tredjepartsleverantör eller i Learnifier.",
  "Multiple learning items of different types, formats, and delivery modes based on a common topic or role, organized in one space. The items do not have to be completed in a specific order.": "Ett flertal lärobjekt av olika typer, format och leveransmetoder baserade på ett gemensamt ämne eller roll, samlade på ett ställe. Lärobjekten måste inte slutföras i en specifik ordning.",
  "view": "View",
  "save": "Save",
  "page": "Page",
  "document": "Document",
  "write-your-content": "Write your content",
  "video": "Video",
  "add-video-url": "Add video URL",
  "close": "Close",
  "add": "Add"
}
